// language=GraphQL
export const ALL_ACCOMMODATIONS_QUERY = `query Query($withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
  accommodations: accommodations {
    id
    label
    name
    stars
    description
    roomTypes @include(if: $withRoomTypes) {
      id
      name
      description
      gallery @include(if: $withRoomTypesGallery) {
        id
        images @include(if: $withRoomTypesGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    availableAddons @include(if: $withAvailableAddons) {
      id
      name
      description
      icon @include(if: $withAvailableAddonsIcon) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_ACCOMMODATION_QUERY = `query Query($id: ID!, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
  accommodation: accommodation(id: $id) {
    id
    label
    name
    stars
    description
    roomTypes @include(if: $withRoomTypes) {
      id
      name
      description
      gallery @include(if: $withRoomTypesGallery) {
        id
        images @include(if: $withRoomTypesGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    availableAddons @include(if: $withAvailableAddons) {
      id
      name
      description
      icon @include(if: $withAvailableAddonsIcon) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const CREATE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: CreateAccommodationInput, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
    accommodation: createAccommodation(input: $input) {
      id
      label
      name
      stars
      description
      roomTypes @include(if: $withRoomTypes) {
        id
        name
        description
        gallery @include(if: $withRoomTypesGallery) {
          id
          images @include(if: $withRoomTypesGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      availableAddons @include(if: $withAvailableAddons) {
        id
        name
        description
        icon @include(if: $withAvailableAddonsIcon) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: UpdateAccommodationInput, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
    accommodation: updateAccommodation(input: $input) {
      id
      label
      name
      stars
      description
      roomTypes @include(if: $withRoomTypes) {
        id
        name
        description
        gallery @include(if: $withRoomTypesGallery) {
          id
          images @include(if: $withRoomTypesGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      availableAddons @include(if: $withAvailableAddons) {
        id
        name
        description
        icon @include(if: $withAvailableAddonsIcon) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: DeleteAccommodationInput) {
    deleteAccommodation(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: DeleteAccommodationInput) {
    forceDeleteAccommodation(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ACCOMMODATION_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: addAccommodationRoomTypesInput) {
    addAccommodationRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const REMOVE_ACCOMMODATION_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: removeAccommodationRoomTypesInput) {
    removeAccommodationRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const CREATE_ACCOMMODATION_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: createAccommodationRoomTypesInput) {
    createAccommodationRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_ROOM_TYPES_MUTATION = `
  mutation Mutation($input: deleteAccommodationRoomTypesInput) {
    deleteAccommodationRoomTypes(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_ROOM_TYPES_ORDER_MUTATION = `
  mutation Mutation($input: updateAccommodationRoomTypesOrderInput) {
    updateAccommodationRoomTypesOrder(input: $input) {
      id
      roomTypeIds
    }
  }`

// language=GraphQL
export const ADD_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = `
  mutation Mutation($input: addAccommodationAvailableAddonsInput) {
    addAccommodationAvailableAddons(input: $input) {
      id
      availableAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = `
  mutation Mutation($input: removeAccommodationAvailableAddonsInput) {
    removeAccommodationAvailableAddons(input: $input) {
      id
      availableAddonIds
    }
  }`

// language=GraphQL
export const CREATE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = `
  mutation Mutation($input: createAccommodationAvailableAddonsInput) {
    createAccommodationAvailableAddons(input: $input) {
      id
      availableAddonIds
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = `
  mutation Mutation($input: deleteAccommodationAvailableAddonsInput) {
    deleteAccommodationAvailableAddons(input: $input) {
      id
      availableAddonIds
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_AVAILABLE_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateAccommodationAvailableAddonsOrderInput) {
    updateAccommodationAvailableAddonsOrder(input: $input) {
      id
      availableAddonIds
    }
  }`

// language=GraphQL
export const ACCOMMODATIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelAccommodationAssignments: Boolean = false, $withTravels: Boolean = false) {
  groupedDependents: accommodationDependents(id: $id) {
    travelAccommodationAssignments @include(if: $withTravelAccommodationAssignments) {
      id
      useCustomRoomTypeSelection    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
  }
}`
